const getters = {
    avatar: state =>{ 
        return state.user.user.customerImg
    },
    name: state => {
        if (state.user.user){
            return state.user.user.customerNickname
        }
        let usr = JSON.parse(localStorage.getItem("user"))
        if (usr){
            return usr.customerNickname
        }
        return null
    },
    uid: state => {
        if (state.user.user) {
        return state.user.user.userId}
        
        let usr = JSON.parse(localStorage.getItem("user"))
        if(usr) {
            return usr.userId
        }
        return null
    }
        ,
    phone: state => {
        if (state.user.user) {
            return state.user.user.phone
        }

        let usr = JSON.parse(localStorage.getItem("user"))
        if (usr) {
            return usr.phone
        }
        return null
    },
    username: state => {
        if (state.user.user) {
            return state.user.user.username
        }

        let usr = JSON.parse(localStorage.getItem("user"))
        if (usr) {
            return usr.username
        }
        return null
    },
    user: state => {
        if (state.user.user) {
            return state.user.user
        }

        let usr = JSON.parse(localStorage.getItem("user"))
        console.log("Store",usr)
        if (usr) {
            return usr
        }
        return null
    },
    team: state => {
        if (state.user.user) {
            return state.user.user.team
        }

        let usr = JSON.parse(localStorage.getItem("user"))
        if (usr) {
            return usr.team
        }
        return 0
    },
    teamStatus: state => {
        if (state.user.team) {
            return state.user.team.teamStatus
        }

        let team = JSON.parse(localStorage.getItem("team"))
        if (team) {
            return team.status
        }
        return null
    }
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js